import { normalizeCourseTabName } from "../../../../utils/normalizeCourseShape";

export function remapPestanaListAfterRename(pestanas, oldKey, newKey) {
  if (!Array.isArray(pestanas)) {
    return [];
  }
  const fromName = normalizeCourseTabName(oldKey);
  const toName = normalizeCourseTabName(newKey);
  if (!fromName || !toName) {
    return pestanas;
  }
  return pestanas.map((p) => (normalizeCourseTabName(p) === fromName ? toName : p));
}
